module.exports = __webpack_public_path__ + "static/media/placeholder.979851c1.svg";